var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-section-container",class:['gtc-' + _vm.data.columns, _vm.data.classes]},_vm._l((_vm.data.items),function(item,index){return _c('HomeService',{key:index,attrs:{"name":item.name,"description":item.description,"img":item.img,"classes":[_vm.homeServiceClasses, 'height-auto'],"not-hover":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }